import { loadStripe, Stripe as IStripe } from '@stripe/stripe-js';

/**
 * Instantiates a Stripe object
 *
 * @param {String} accountId String of Stripe connect account ID to instantiate a connection on behalf of the connected account
 *
 * @returns {IStripe} Stripe instance
 */
const Stripe = async (accountId: string): Promise<IStripe> => {
  return (await loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`, {
    stripeAccount: accountId,
  })) as IStripe;
};

export default Stripe;
